const roles = ['Admin'];

export class IdentityProviderIdManager {
  ids: Set<string>;
  index: number;

  constructor() {
    this.ids = new Set();
    this.index = 0;
  }

  fetch(): string {
    let id = 'no more roles available';
    if (this.index + 1 <= roles.length) {
      id = roles[this.index++];
    }
    this.ids.add(id);
    return id;
  }

  set(id: string): void {
    if (this.ids.has(id)) {
      throw new Error('ID ' + id + 'has already been used.');
    }
    this.ids.add(id);
  }

  reset(): void {
    this.ids.clear();
  }
}
